<template>
  <v-container fluid grid-list-lg>
    <Create :createDialog="createDialog" @close="createDialog = false" @submit="getList"></Create>
    <v-card :loading="loading" outlined>
      <ListTitle :title="`${applicationTitle}`" @add="add" />
      <v-card-title>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field v-model="search" outlined prepend-inner-icon="search" rounded dense label="Search" single-line
              hide-details clearable></v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table class="pageHeight" :headers="headers" ref="myTable" :items="financialAidApplications" :search="search"
        :loading="loading" :sort-by="sortBy" :page.sync="page" hide-default-footer :items-per-page="itemsPerPage">
        <template v-slot:item="{ item }">
          <tr class="pointer" @click="viewProfile(item.id)">
            <td class="text-left">
              {{ item.createdAt | moment('MM/DD/YYYY') }}
            </td>
            <td class="text-left">
              <span class="text-capitalize">{{ item.fullName }}</span>
            </td>
            <td class="text-left">
              {{item.phoneNumber}}
            </td>
            <td class="text-center">
              {{item.tried}}
            </td>
            <td class="text-left">
              <v-chip class="text-capitalize" small :color="statusColor(item.status)" dark rounded>
                {{ item.status }}
              </v-chip>
            </td>
            <td class="justify-end align-center text-right">
              <v-menu bottom left offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list class="menu-button">
                  <v-list-item @click="editApplication(item.id)">
                    <v-list-item-title>Edit</v-list-item-title>
                  </v-list-item>
                  <v-divider ></v-divider>
                  <v-list-item @click="deleteApplication(item)">
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import applicationService from "../service";
import { mapGetters } from "vuex";
const Create = () => import("./Create");
export default {
  name: "sadqaFinancialAid-list",
  data() {
    return {
      headers: [],
      financialAidApplications: [],
      search: null,
      loading: true,
      createDialog: false,
      page: 1,
      sortBy: "fullName",
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  components: {
    Create
  },
  async created() {
    await this.getList();
    document.title = "taleem - Financial Aid Application List";
    this.headers.push({
      text: 'Created At',
      align: "left",
      value: "createdAt",
      sortable: true,
    },
    {
      text: this.$t("labels.name"),
      align: "left",
      value: "fullName",
      sortable: true,
    },
    {
      text: 'Phone Number',
      align: "left",
      value: "phoneNumber",
      sortable: true,
    },
    {
      text: 'Tried Count',
      align: "center",
      value: "tried",
      sortable: true,
    },
    {
      text: 'Status',
      align: "left",
      value: "status",
      sortable: true,
    },
    {
      text: "",
      value: "",
      sortable: false,
    })
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    applicationTitle() {
      if (this.$refs.myTable && this.$refs.myTable.selectableItems) {
        return this.$refs.myTable.selectableItems.length + ' Sadqah Financial Aid Applications'
      }
      return this.financialAidApplications.length + ' Sadqah Financial Aid Applications'

    }
  },
  methods: {
    statusColor(status) {
      let color = 'green'
      switch (status) {
        case 'pending':
          color = '#1976D2'
          break;
        case 'declined':
          color = 'red'
          break;
        case 'created':
          color = '#AED581'
          break;
        case 'approved':
          color = '#00BFA5'
          break;
        default:
          color = 'green'
      }

      return color
    },
    add() {
      this.createDialog = true;
    },
    getList() {
      this.loading = true;
      let where = {
        // filteredClasses: this.selectedClasses
      };
      return applicationService.getAll(where).then((response) => {
        console.log('response', response)
        this.loading = false;
        this.financialAidApplications = response.data;
        this.itemsPerPage = this.financialAidApplications.length
      });
    },
    editApplication(applicationId) {
      this.$router.push({ path: `/sadqaFinancialAid/${applicationId}/edit` });
    },
    viewProfile(applicationId) {
      this.$router.push({ path: `/sadqaFinancialAid/${applicationId}/profile` });
    },
    deleteApplication(application) {
      this.$swal({
        title: "Are you sure?",
        text: `You want to remove ${application.fullName}.`,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#B71C1C",
        cancelButtonColor: "#43A047",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          applicationService.delete(application.id).then((response) => {
            if (response.data) {
              this.$swal("Deleted!", "Application has been deleted.", "success");
              this.getList();
            }
          });
        }
      });
    },
  },
};
</script>
